import React from 'react';
import { Link } from 'react-router-dom';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { useStoreOnboarding } from '../../../context';
import { useFTUWizard } from '../../context';
import { ReactComponent as ClipboardCheckIcon } from 'assets/ss-icons/clipboard-check.svg';
import { ReactComponent as ParcelIcon } from 'assets/ss-icons/parcel.svg';
import { ReactComponent as TreeNodesIcon } from 'assets/ss-icons/tree-nodes.svg';

export default function FTUCompleted() {
  const { onMarkTodoDone } = useStoreOnboarding();
  const { onToggle } = useFTUWizard();

  return (
    <>
      <UiKit.Flex direction="column" align="center">
        <UiKit.Flex direction="column" align="center" gap={8} className="p-4">
          <UiKit.Title>Basic set up complete!</UiKit.Title>
          <UiKit.Text>
            Your customers can now create returns on their own.
          </UiKit.Text>
        </UiKit.Flex>
        <UiKit.Card className={styles.card}>
          <UiKit.Card.Body className={styles.cardContent}>
            <UiKit.Flex direction="column" align="center" gap={24}>
              <UiKit.Flex direction="column" align="center" gap={16}>
                <UiKit.Text weight="bold" size="lg">
                  Next, let’s set up and brand your customer returns portal
                </UiKit.Text>
                <UiKit.Flex direction="column" gap={12}>
                  <UiKit.Flex gap={8} align="center">
                    <UiKit.Flex
                      align="center"
                      justify="center"
                      className={styles.icon}
                    >
                      <ClipboardCheckIcon />
                    </UiKit.Flex>
                    <UiKit.Text>
                      Add your stores brand colors and logos.
                    </UiKit.Text>
                  </UiKit.Flex>
                  <UiKit.Flex gap={8} align="center">
                    <UiKit.Flex
                      align="center"
                      justify="center"
                      className={styles.icon}
                    >
                      <ParcelIcon />
                    </UiKit.Flex>
                    <UiKit.Text>
                      Keep your customer experience consistent.
                    </UiKit.Text>
                  </UiKit.Flex>
                  <UiKit.Flex gap={8} align="center">
                    <UiKit.Flex
                      align="center"
                      justify="center"
                      className={styles.icon}
                    >
                      <TreeNodesIcon />
                    </UiKit.Flex>
                    <UiKit.Text>Show off your brand after the sale.</UiKit.Text>
                  </UiKit.Flex>
                </UiKit.Flex>
              </UiKit.Flex>
              <UiKit.Flex gap={16}>
                <UiKit.Button variant="outline" onClick={onToggle}>
                  I'll do this later
                </UiKit.Button>
                <Link to="/configure/customer-portal/branded-theme">
                  <UiKit.Button onClick={() => onMarkTodoDone('BRANDED_THEME')}>
                    Continue setup
                  </UiKit.Button>
                </Link>
              </UiKit.Flex>
            </UiKit.Flex>
          </UiKit.Card.Body>
        </UiKit.Card>
      </UiKit.Flex>
      <UiKit.Sheet.ActionsPortal>
        <UiKit.Button size="lg" onClick={onToggle}>
          Continue to Dashboard
        </UiKit.Button>
      </UiKit.Sheet.ActionsPortal>
    </>
  );
}
